import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { map, Observable, startWith } from 'rxjs';

import { CustomValidators } from '@smartcharge/shared/index';

import { WhitelabelInstance } from 'src/app/services/whitelabel/whitelabel-instance.service';
import { UserType } from 'src/app/user-roles';
import { HttpInterceptorService } from '../../../services';
import { ToastService } from '../../../shared/services/toast/toast.service';

@Component({
  selector: 'sc-create-customer',
  templateUrl: './create-customer.component.html',
  styleUrls: ['./create-customer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CreateCustomerComponent implements OnInit {
  customerForm: FormGroup;
  presets: any = {};
  languages: any[] = [];
  redirectToApp: boolean = false;
  showRedirectOption: boolean = true;

  operators: any[] = [];
  filteredOperators: Observable<any> = new Observable();
  operatorSearchVal: string;
  userType = UserType;
  operatorID: any; //Input to prefill

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<CreateCustomerComponent>,
    private _http: HttpInterceptorService,
    public whiteLabelInstance: WhitelabelInstance,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.initForm();
    this.initLanguages();
    this.getOperators();
  }
  initLanguages() {
    this._http.get('Users/GetSupportedLanguages').subscribe({
      next: (res) => {
        this.languages = res?.datas || [];
        this.selectDefaultLanguage();
      },
      error: (err) => {}
    });
  }
  initForm() {
    this.customerForm = this.formBuilder.group({
      FirstName: [this.presets.FirstName || ''],
      LastName: [this.presets.LastName || ''],
      Email: [this.presets.Email || '', [Validators.required, CustomValidators.email]],
      Language: ['', Validators.required],
      PhoneNumber: [this.presets.PhoneNumber || ''],
      RedirectToApp: [this.redirectToApp],
      Operator: []
    });
  }
  displayFnOperator(operator) {
    return operator ? operator.Name : operator;
  }

  getOperators() {
    this._http.get('Operators/OperatorsICanSee').subscribe((res) => {
      if (!res.datas) return;
      this.operators = res.datas.filter((operator) => operator.appTokenWhiteLabel);

      this.filteredOperators = Observable.create();
      this.filteredOperators = this.customerForm.controls.Operator.valueChanges
        .pipe(startWith<string | any>(''))
        .pipe(map((searchVal) => this.filterOperators(searchVal)));

      if (this.operatorID) {
        let operator = this.operators.filter((op) => op.PK_OperatorID == this.operatorID)[0];
        this.customerForm.controls.Operator.patchValue(operator);
      }
    });
  }
  clearOperator() {
    this.customerForm.get('Operator').reset();
  }
  filterOperators(searchVal) {
    this.operatorSearchVal = searchVal;
    if (!searchVal) return this.operators;
    searchVal = searchVal.toString();
    return this.operators.filter((item) => item.Name && item.Name.toLowerCase().indexOf(searchVal.toLowerCase()) === 0);
  }
  saveCustomer(ev) {
    ev.preventDefault();
    if (this.customerForm.invalid) return;
    let customerObj = Object.assign({}, this.customerForm.value);
    customerObj.appToken = this.whiteLabelInstance.whitelabelID;
    if (customerObj.Operator) customerObj.FK_OperatorID = customerObj.Operator.PK_OperatorID;

    this._http.post('Users/SemiRegisterUser', customerObj).subscribe({
      next: (res) => {
        if (res && res.datas) {
          if (!res.datas.customer) {
            //FIX: Remove when backend is pushed. Old way
            let customer = Object.assign({}, this.customerForm.value);
            customer.PK_CustomerID = res.datas.FK_CustomerID;
            customer.FK_UserID = res.datas.FK_UserID;
            this.dialogRef.close(customer);
          } else {
            this.dialogRef.close(res.datas.customer);
          }
        } else {
          this.toastService.error();
        }
      },
      error: (err) => {
        this.toastService.error(err);
      }
    });
  }
  private getLang() {
    let lang = window.navigator.language.substring(0, 2);
    return lang === 'nn' ? 'nb' : lang;
  }
  selectDefaultLanguage() {
    const browserLang = this.getLang();
    const supportedLangs = this.languages.map((lang) => lang.Key);
    this.customerForm.controls.Language.patchValue(supportedLangs.includes(browserLang) ? browserLang : 'en');
  }
}
